var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('h2',[_vm._v("Statistiques générales")]),_c('team-statistics-possession',{attrs:{"match":_vm.match,"team":_vm.team}}),_vm._l((_vm.statistics),function(stat){return _c('team-statistics-template',{key:stat.id,attrs:{"match":_vm.match,"team":_vm.team,"statistic":stat}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }